import globals from '../../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const cadastrarRemuneracaoSeller = async (idEmpresa,data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/cadastrar-remuneracao-seller/${idEmpresa}/`, 'POST', data)
}

export const editarRemuneracao = async (idEmpresa,data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/atualizar-remuneracao-seller/${idEmpresa}/`, 'PUT', data)
}

export const obterIdRemuneracaoSeller = async (idEmpresa) => {
    //alert(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/id-remuneracao-seller/${idEmpresa}`);
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/id-remuneracao-seller/${idEmpresa}`, 'GET')
}

export const detalheRemuneracaoSeller = async (idRemuneracao,idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/detalhes-remuneracao-seller/${idRemuneracao}/${idEmpresa}/`, 'GET')
}

export const inativarRemuneracaoSeller = async (idRemuneracaoSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/inativar-remuneracao-seller/${idRemuneracaoSeller}/`, 'PUT')
}

export const ativarRemuneracaoSeller = async (idRemuneracaoSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}RemuneracaoGreenersSeller/ativar-remuneracao-seller/${idRemuneracaoSeller}/`, 'PUT')
}
